module.cC({
    name: 'CertificateIndexController',
    inject: ['$scope', '$state', 'student', 'certificates',
             'ModelConfig', 'Notifications', 'ModelService'],

    data: {
        certificates: 'certificates',
    },

    init: function() {
        this.$.options = this.ModelConfig.getOptions(
            ['certificate_name', 'certificate_type']);
    },

    listen: {
        certificate: {
            create: '_insertCertificate',
        }
    },

    methods: {
        certName: function(cert) {
            if (cert.certificate_name == 'other') {
                return cert.other_name || "Unknown Certificate";
            }
            return this.$.options && this.$.options.certificate_name[cert.certificate_name];
        },

        _insertCertificate: function(id, owner) {
            if (owner === this.student.id) {
                this.ModelService.debouncedGet('certificate', id)
                    .then(this.ModelService.appendToArray(this.certificates));
            }
        },
    }
});
